import { render } from "./AvatarSetter.vue?vue&type=template&id=719769da&scoped=true"
import script from "./AvatarSetter.vue?vue&type=script&lang=js"
export * from "./AvatarSetter.vue?vue&type=script&lang=js"

import "./AvatarSetter.vue?vue&type=style&index=0&id=719769da&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-719769da"]])

export default __exports__